(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-experience"] && !Shopify.designMode) return;
  try {
    
  class ContactExperience extends HTMLElement {
    connectedCallback() {
      if (!this._selectReady) {
        this._selectReady = this.initCustomSelect();
      } else if (this._handleDocumentClick) {
        // re-attach document-level listeners after a reconnect (they are removed on disconnect)
        document.addEventListener('click', this._handleDocumentClick);
        document.addEventListener('keydown', this._handleDocumentKey);
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.classList.add('contact-experience--motion-ready');
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;
          this.classList.add('contact-experience--visible');
          this.observer?.disconnect();
        },
        { threshold: 0.12 }
      );
      this.observer.observe(this);
    }

    initCustomSelect() {
      const wrapper = this.querySelector('[data-custom-select]');
      const recipientInput = this.querySelector('input[name="contact[Send to]"]');
      const departmentInput = this.querySelector('input[name="contact[Department]"]');
      const nativeSelect = this.querySelector('select[name="contact[subject]"]');

      if (!wrapper || !nativeSelect) return false;

      const trigger = wrapper.querySelector('.contact-experience__select-button');
      const valueDisplay = wrapper.querySelector('.contact-experience__select-current');
      const menu = wrapper.querySelector('.contact-experience__select-menu');
      const items = Array.from(wrapper.querySelectorAll('.contact-experience__select-item'));

      const syncInputs = (value, recipient) => {
        if (recipientInput) recipientInput.value = recipient;
        if (departmentInput) departmentInput.value = value;
      };

      const closeDropdown = () => {
        wrapper.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
      };

      const openDropdown = () => {
        wrapper.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
        const selectedItem = wrapper.querySelector('.contact-experience__select-item.is-selected') || items[0];
        selectedItem?.focus();
      };

      const selectItem = (item) => {
        const val = item.getAttribute('data-value') || '';
        const recipient = item.getAttribute('data-recipient') || (val === 'After sales and services' ? 'aftersales@ist1947.com' : 'contact@ist1947.com');
        const text = item.querySelector('.contact-experience__select-item-text')?.textContent?.trim() || val;

        if (valueDisplay) {
          valueDisplay.textContent = text;
        }

        items.forEach((it) => {
          const isCurrent = it === item;
          it.classList.toggle('is-selected', isCurrent);
          it.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        });

        nativeSelect.value = val;
        syncInputs(val, recipient);
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        closeDropdown();
        trigger?.focus();
      };

      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (wrapper.classList.contains('is-open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openDropdown();
          }
        });
      }

      items.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          selectItem(item);
        });

        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectItem(item);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const next = items[index + 1] || items[0];
            next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = items[index - 1] || items[items.length - 1];
            prev.focus();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeDropdown();
            trigger?.focus();
          } else if (e.key === 'Tab') {
            closeDropdown();
          }
        });
      });

      this._handleDocumentClick = (e) => {
        if (!wrapper.contains(e.target)) {
          closeDropdown();
        }
      };
      document.addEventListener('click', this._handleDocumentClick);

      this._handleDocumentKey = (e) => {
        if (e.key === 'Escape' && wrapper.classList.contains('is-open')) {
          closeDropdown();
          trigger?.focus();
        }
      };
      document.addEventListener('keydown', this._handleDocumentKey);

      // Handle native select changes (e.g. autofill or reset)
      nativeSelect.addEventListener('change', () => {
        const matchingItem = items.find((it) => it.getAttribute('data-value') === nativeSelect.value);
        if (matchingItem) {
          const val = matchingItem.getAttribute('data-value') || '';
          const recipient = matchingItem.getAttribute('data-recipient') || (val === 'After sales and services' ? 'aftersales@ist1947.com' : 'contact@ist1947.com');
          const text = matchingItem.querySelector('.contact-experience__select-item-text')?.textContent?.trim() || val;

          if (valueDisplay) valueDisplay.textContent = text;
          items.forEach((it) => {
            const isCurrent = it === matchingItem;
            it.classList.toggle('is-selected', isCurrent);
            it.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
          });
          syncInputs(val, recipient);
        }
      });

      // Initial synchronization
      const initialSelected = wrapper.querySelector('.contact-experience__select-item.is-selected') || items[0];
      if (initialSelected) {
        const val = initialSelected.getAttribute('data-value') || '';
        const recipient = initialSelected.getAttribute('data-recipient') || (val === 'After sales and services' ? 'aftersales@ist1947.com' : 'contact@ist1947.com');
        syncInputs(val, recipient);
      }

      return true;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this._handleDocumentClick) {
        document.removeEventListener('click', this._handleDocumentClick);
      }
      if (this._handleDocumentKey) {
        document.removeEventListener('keydown', this._handleDocumentKey);
      }
    }
  }

  if (!customElements.get('contact-experience')) {
    customElements.define('contact-experience', ContactExperience);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('heritage-collections')) {
    customElements.define(
      'heritage-collections',
      class HeritageCollections extends HTMLElement {
        connectedCallback() {
          this.classList.add('--motion-ready');

          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry?.isIntersecting) return;
              this.classList.add('--visible');
              this.observer?.disconnect();
            },
            { threshold: 0.08 }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-story-cards')) {
    customElements.define(
      'product-story-cards',
      class ProductStoryCards extends HTMLElement {
        connectedCallback() {
          this.classList.add('--motion-ready');

          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry?.isIntersecting) return;
              this.classList.add('--visible');
              this.observer?.disconnect();
            },
            { threshold: 0.08 }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-manual-library"] && !Shopify.designMode) return;
  try {
    
  class ManualLibrary extends HTMLElement {
    constructor() {
      super();
      this.handleModelChange = this.handleModelChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleModelChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleModelChange);
    }

    handleModelChange(event) {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-manual-select]')) return;

      const card = event.target.closest('.manual-card');
      const selectedOption = event.target.selectedOptions[0];
      const image = card?.querySelector('[data-manual-image]');
      const placeholder = card?.querySelector('[data-manual-placeholder]');
      const imageUrl = selectedOption?.dataset.imageUrl;

      if (!(image instanceof HTMLImageElement) || !(placeholder instanceof HTMLElement)) return;

      if (imageUrl) {
        image.src = imageUrl;
        image.alt = selectedOption.dataset.imageAlt || selectedOption.textContent?.trim() || '';
        image.classList.remove('is-hidden');
        placeholder.classList.add('is-hidden');
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.classList.add('is-hidden');
        placeholder.classList.remove('is-hidden');
      }
    }
  }

  if (!customElements.get('manual-library')) {
    customElements.define('manual-library', ManualLibrary);
  }

  } catch(e) { console.error(e); }
})();
})();
